import { getApps, getAppInfo } from './getAppInfo';
import Promise from 'Promise';
import { getApplication } from 'learnRuntime/applications';
import { loadAssets, fetchManifest } from './assets';
import initGlobalNav from './GlobalNav/index';
import I18n from '@get-bridge/learn-legacy-shared/dist/shimmed_modules/I18n';

function unmountApp(app, initializers) {
  if (app) {
    return getApplication(app.name).unmount(initializers);
  } else {
    return Promise.resolve();
  }
}

export default function handleAppChange({ appState, domNode, navNode }) {
  let currentInitializers = {};
  let currentAppConfig;
  let assets = {};

  function changeApp() {
    return new Promise(resolve => {
      appState.startSwitching();
      unmountApp(currentAppConfig, currentInitializers).then(() => {
        currentAppConfig =
          getAppInfo(window.location.pathname) || getAppInfo('/');
        const appAssets = assets.hasOwnProperty(currentAppConfig.name)
          ? assets[currentAppConfig.name]
          : assets['bridge-learn'];
        loadAssets(currentAppConfig, appAssets).then(() => {
          getApplication(currentAppConfig.name)
            .mount({
              appState,
              changeApp,
              domNode,
            })
            .then(initializers => {
              I18n.enableLookups();
              initGlobalNav(
                navNode,
                currentAppConfig,
                initializers.config.find(
                  initializer => initializer.id === 'router',
                ),
              );
              currentInitializers = initializers;
              appState.stopSwitching();
              resolve();
            });
        });
      });
    });
  }

  const remoteManifests = getApps()
    .filter(a => !!a.manifest)
    .map(app =>
      fetchManifest(app).then(manifest => {
        assets[app.name] = manifest;
      }),
    );
  return Promise.all(remoteManifests)
    .then(changeApp)
    .catch(err => {
      throw new Error(`error fetching asset manifest: ${err}`);
    });
}



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/handleAppChange.js